import { FC } from "react";
import { useParams } from "react-router-dom";
import useBasePath from "src/utils/hooks/useBasePath";
import { Alert, Paper } from "@mui/material";
import __ from "src/utils/Translations";
import {
  useFetchAbsenceTypeHistory,
  useGetAbsenceType,
} from "src/Pages/Company/Absences/api/useAbsenceTypes";
import BreadcrumbsMui from "src/Components/BreadcrumbsMui/BreadcrumbsMui";
import Title from "src/Pages/Company/Absences/Title/Title";
import AbsenceRequestFormPreview from "src/Pages/Company/Absences/AbsenceRequest/AbsenceRequestForm/AbsenceRequestFormPreview";
import { Loader } from "src/Components/Loader/Loader";
import ErrorDataFetching from "src/Components/Error/ErrorDataFetching";
import AbsenceTypeHistory from "./AbsenceTypeHistory/AbsenceTypeHistory";

const AbsenceTypePreview: FC = () => {
  const { absenceTypeId } = useParams<Record<string, string>>();
  const basePath = useBasePath();

  const {
    data: absenceType,
    isFetching: isFetchingAbsenceType,
    isError: isErrorAbsenceType,
    isSuccess: isSuccessAbsenceType,
  } = useGetAbsenceType(absenceTypeId);

  const {
    data: absenceTypeHistory,
    isFetching: isFetchingAbsenceTypeHistory,
    isError: isErrorAbsenceTypeHistory,
  } = useFetchAbsenceTypeHistory(absenceTypeId);

  return (
    <>
      <BreadcrumbsMui
        items={[
          {
            label: __("Nieobecności"),
            to: `${basePath}/absences`,
          },
          {
            label: __("Szablony wniosków"),
            to: `${basePath}/absences/absence-types`,
          },
          {
            label: `${__("Podgląd szablonu wniosku")} ${
              absenceType?.name || ""
            }`,
          },
        ]}
      />
      <Title
        title={`${__("Podgląd szablonu wniosku")} ${absenceType?.name || ""}`}
      />
      <Paper
        sx={{ position: "relative", minHeight: "100px", p: "2rem" }}
        data-testid="absence-type-preview"
      >
        {isFetchingAbsenceType && <Loader />}
        {isErrorAbsenceType && <ErrorDataFetching />}
        {isSuccessAbsenceType && absenceType && (
          <AbsenceRequestFormPreview
            key={absenceTypeId}
            absenceType={absenceType}
          />
        )}
      </Paper>

      <Paper
        sx={{
          position: "relative",
          minHeight: "100px",
          padding: "1rem",
          mt: "2rem",
        }}
        data-testid="absence-type-history"
      >
        {/* eslint-disable-next-line no-nested-ternary */}
        {isErrorAbsenceTypeHistory ? (
          <Alert severity="error">
            {__("Błąd pobierania danych historii szablonu wniosku.")}
          </Alert>
        ) : isFetchingAbsenceTypeHistory ? (
          <Loader />
        ) : (
          absenceTypeHistory && <AbsenceTypeHistory data={absenceTypeHistory} />
        )}
      </Paper>
    </>
  );
};

export default AbsenceTypePreview;
